module.exports = __webpack_public_path__ + "static/media/terry-moye.265e408f.jpg";